(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name itecAdministracio.controller:AppCtrl
     *
     * @description
     *
     */
    angular
      .module('itecAdministracio')
      .controller('AppCtrl', AppCtrl);

    function AppCtrl(theme, headerMenuLinks, headerMenuIconsPosition, $timeout, AdmConstant, DataFactory, $location, $scope, AppWrapperFactory, $rootScope,LogoutFactory, deviceDetector, ApiLayoutConstant, PermisosFactory,LocaleService, $state, AppFactory) {

      var vm = this;

      $rootScope.modul = theme;

      AdmConstant.SERVER_PATH_ADMINISTRACIO_COMPLETE_API  = 'https://'+$location.$$host+'/api/security/';

      vm.app = {};
      vm.app.theme = theme;
      vm.app.headerMenuLinks = headerMenuLinks;
      vm.app.headerMenuIconsPosition = headerMenuIconsPosition;
      vm.logout=logout;
 

      function logout() {
        var promise = LogoutFactory.get().then(
          function(response){
          }).catch(function(error){
          });
        return promise;
      }

      vm.accesosAppsTCQi = undefined;

      /*
        Hem de fer varies crides paraleles per carregar tota la informació necessaria el primer cop (permisos, configuracions, notificacions, etc). Aquesta estructura permet saber com portem la carrega d'avançada porcentualment.
      */
      vm.initialized    = false;
      vm.loaded         = false;
      var promisesArray = [];
      vm.loadCalls = {
        num: 1,
        done: 0,
        errors: 0,
        initial: 40, //quan arribem aqui, ja tenim una part cargada
        percentage: 0, 
        loaded: false,
        calculate: function() {
          var callsPerc   = (this.done/this.num);
          var ponderat    = callsPerc*(100-this.initial);
          var perc        = this.initial+ponderat;
          this.percentage = Math.min(perc,100);
          this.loaded     = (this.done >= this.num);
        }
      };
      vm.loadCalls.percentage = vm.loadCalls.initial;

      function cridaPosterior(promise) {
        promisesArray.push(promise);
        
        vm.loadCalls.num++;
        promise.then(function(){
          vm.loadCalls.done++;
          vm.loadCalls.calculate();
        }).catch(function(){
          vm.loadCalls.done++;
          vm.loadCalls.errors++;
          vm.loadCalls.calculate();
        }); 
      }

      function endInitialization(delay) {
        //ho encapsulo en un timeout per allargar la directiva de loading esperant al renderitzat, pero caldria una solucio mes optima
        vm.loadCalls.calculate();
        $timeout(function() {
          AppFactory.setAppInitialized(true);
          vm.initialized = AppFactory.getAppInitialized();
        }, delay || 0);
      }

      function loadEndingInsurance() {
        //en cas d'error "d'infinit" al promisesArray, posem aquest metode per assegurar-nos que informara al AppFactory igualment als 10 segons.
        endInitialization(10000);
      }


      //Per evitar multiples crides paral·leles que causen un 'session expired' error primer fem una que obté els permisos i de pas crea una sessió unica, i després fem totes les crides conseqüents.
      PermisosFactory.loadWithURL(ApiLayoutConstant.SERVER_PATH_ADMINISTRACIO + 'accesos').then(function(response) {
        vm.accesosAppsTCQi = response.data.acces;
        vm.loadCalls.done++;
        endInitialization(2000);          
      }).catch(function(error){
        endInitialization();
        console.log(error);
        $state.go('pagenotfound');
      }).finally(function(){
        loadEndingInsurance();
      });


      AppWrapperFactory.init($scope);

      var miliseconds = 0;
      if (angular.equals(deviceDetector.browser, 'firefox')) {
        // Se necesita retrasar 2 segundos la carga del contenido para que Angular en Firefox
        // detecte las capas con "scroll" mediante el evento 'tcqiAppLoaded'.
        miliseconds = 2000;
      }

      vm.loaded = false;
      $scope.$on('$viewContentLoaded', function(ev, data){
        $timeout(function() {
          vm.loaded = true;
          $rootScope.$broadcast('tcqiAppLoaded');
        }, miliseconds);
      });
    }
}());
